var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';

var Balloon = function (_React$PureComponent) {
  _inherits(Balloon, _React$PureComponent);

  function Balloon() {
    _classCallCheck(this, Balloon);

    return _possibleConstructorReturn(this, (Balloon.__proto__ || Object.getPrototypeOf(Balloon)).apply(this, arguments));
  }

  _createClass(Balloon, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        {
          style: _extends({
            position: 'absolute',
            padding: '8px 10px 6px',
            backgroundColor: '#2d3038',
            color: '#FAFAFA',
            borderRadius: 2,
            fontFamily: '"Lucida Console", Monaco, monospace',
            fontSize: 11,
            maxWidth: 300,
            marginTop: 10,
            textRendering: 'optimizeLegibility'
          }, this.props.style)
        },
        React.createElement('div', {
          style: {
            position: 'absolute',
            top: -8,
            left: 12,
            width: 0,
            height: 0,
            borderBottom: '8px solid #2d3038',
            borderLeft: '8px solid transparent',
            borderRight: '8px solid transparent'
          }
        }),
        this.props.children,
        React.createElement('div', {
          style: {
            position: 'absolute',
            left: 0,
            right: 0,
            top: -14,
            height: 14
          }
        })
      );
    }
  }]);

  return Balloon;
}(React.PureComponent);

Balloon.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object
};
Balloon.defaultProps = {
  style: {}
};
export default Balloon;


//////////////////
// WEBPACK FOOTER
// ../lib/components/Balloon.js
// module id = 113
// module chunks = 0